var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_959",
    "data-name": "Grupo 959",
    transform: "translate(0.087 0.087)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_454",
    "data-name": "Rect\\xE1ngulo 454",
    width: 16,
    height: 16,
    transform: "translate(-0.087 -0.087)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1692",
    "data-name": "Trazado 1692",
    d: "M46.924,45.511V42.543a.5.5,0,0,0-.495-.495H44.451a.5.5,0,0,0-.495.495v2.968a.5.5,0,0,1-.495.495H40.495A.5.5,0,0,1,40,45.511V39.8a.5.5,0,0,1,.162-.366l4.946-4.5a.5.5,0,0,1,.665,0l4.946,4.5a.5.5,0,0,1,.162.366v5.716a.5.5,0,0,1-.495.495H47.418a.5.5,0,0,1-.495-.495Z",
    transform: "translate(-37.527 -32.652)",
    fill: "none",
    stroke: "#e73758",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.05ecd86d03381ede53d1655a0827b6c2.svg";
export { ForwardRef as ReactComponent };